'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SelectedCredential(credential, selected) {
  this.lI = null;
  this.Ef = false;
  this.lI = credential;
  this.Ef = selected;
}
export { $c_Lpresto_types$SelectedCredential as $c_Lpresto_types$SelectedCredential };
$p = $c_Lpresto_types$SelectedCredential.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SelectedCredential;
/** @constructor */
function $h_Lpresto_types$SelectedCredential() {
}
export { $h_Lpresto_types$SelectedCredential as $h_Lpresto_types$SelectedCredential };
$h_Lpresto_types$SelectedCredential.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("SelectedCredential"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.lI));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.Ef ? 1231 : 1237));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 2);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$SelectedCredential)) {
    if ((this.Ef === x$0.Ef)) {
      var x = this.lI;
      var x$2 = x$0.lI;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "SelectedCredential";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.lI;
  }
  if ((n === 1)) {
    return this.Ef;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.jW = (function() {
  return this.lI.n0;
});
$p.csU = (function() {
  return this.lI;
});
function $isArrayOf_Lpresto_types$SelectedCredential(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ka)));
}
export { $isArrayOf_Lpresto_types$SelectedCredential as $isArrayOf_Lpresto_types$SelectedCredential };
var $d_Lpresto_types$SelectedCredential = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SelectedCredential, "presto.types$SelectedCredential", ({
  ka: 1,
  aH: 1,
  k9: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$SelectedCredential as $d_Lpresto_types$SelectedCredential };
//# sourceMappingURL=presto.types$-Selected-Credential.js.map
